export const styles = {
  // Header Styles
  header: {
    backgroundColor: '#494eb6',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    padding: '1rem 0'
  },
  headerContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  headerLogo: {
    display: 'flex',
    alignItems: 'center',
    color: 'white'
  },
  headerTitle: {
    fontSize: '2rem',
    fontWeight: 'bold',
    margin: 0,
    marginLeft: '0.75rem'
  },
  headerNav: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.5rem'
  },
  headerPhone: {
    display: 'flex',
    alignItems: 'center',
    color: 'white',
    textDecoration: 'none',
    transition: 'color 0.3s'
  },
  headerButton: {
    backgroundColor: 'white',
    color: '#494eb6',
    padding: '0.5rem 1.5rem',
    borderRadius: '8px',
    fontWeight: 'bold',
    textDecoration: 'none',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.3s'
  },

  // Hero Styles
  hero: {
    padding: '5rem 1rem',
    textAlign: 'center'
  },
  heroContainer: {
    maxWidth: '1200px',
    margin: '0 auto'
  },
  heroTitle: {
    fontSize: '3.5rem',
    fontWeight: 'bold',
    color: '#494eb6',
    marginBottom: '1.5rem',
    lineHeight: '1.2'
  },
  heroSubtitle: {
    fontSize: '1.5rem',
    color: '#494eb6',
    marginBottom: '2rem',
    maxWidth: '800px',
    margin: '0 auto 2rem auto'
  },
  heroButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    alignItems: 'center'
  },
  primaryButton: {
    backgroundColor: '#494eb6',
    color: 'white',
    padding: '1rem 2rem',
    fontSize: '1.25rem',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    transition: 'opacity 0.3s',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
  },
  secondaryButton: {
    backgroundColor: 'transparent',
    color: '#494eb6',
    padding: '1rem 2rem',
    fontSize: '1.25rem',
    fontWeight: 'bold',
    border: '2px solid #494eb6',
    borderRadius: '8px',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    transition: 'background-color 0.3s'
  },

  // Section Styles
  section: {
    padding: '5rem 1rem'
  },
  sectionContainer: {
    maxWidth: '1200px',
    margin: '0 auto'
  },
  sectionTitle: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: '#494eb6',
    textAlign: 'center',
    marginBottom: '1rem'
  },
  sectionDescription: {
    fontSize: '1.125rem',
    color: '#666',
    textAlign: 'center',
    maxWidth: '600px',
    margin: '0 auto 4rem auto'
  },

  // Services Styles
  servicesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '2rem'
  },
  serviceCard: {
    backgroundColor: 'white',
    padding: '2rem',
    borderRadius: '12px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    border: '2px solid #494eb6',
    transition: 'transform 0.3s, box-shadow 0.3s'
  },
  serviceIcon: {
    color: '#494eb6',
    marginBottom: '1rem',
    fontSize: '2rem'
  },
  serviceTitle: {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    color: '#494eb6',
    marginBottom: '0.75rem'
  },
  serviceDescription: {
    color: '#666'
  },

  // Why Choose Us Styles
  whyChooseUs: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    padding: '5rem 1rem'
  },
  whyGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '2rem'
  },
  whyCard: {
    textAlign: 'center'
  },
  whyIcon: {
    color: '#494eb6',
    marginBottom: '1rem',
    display: 'flex',
    justifyContent: 'center',
    fontSize: '3rem'
  },
  whyTitle: {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    color: '#494eb6',
    marginBottom: '0.75rem'
  },
  whyDescription: {
    color: '#666'
  },

  // Contact Styles
  contactSection: {
    padding: '5rem 1rem'
  },
  contactContainer: {
    maxWidth: '1000px',
    margin: '0 auto'
  },
  contactGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
    gap: '3rem'
  },
  contactInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem'
  },
  contactInfoTitle: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#494eb6',
    marginBottom: '1.5rem'
  },
  contactItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  contactIcon: {
    color: '#494eb6'
  },
  contactLabel: {
    fontWeight: 'bold',
    color: '#494eb6',
    marginBottom: '0.25rem'
  },
  contactValue: {
    color: '#666',
    textDecoration: 'none'
  },

  // Form Styles
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column'
  },
  label: {
    fontWeight: 'bold',
    color: '#494eb6',
    marginBottom: '0.5rem',
    fontSize: '0.875rem'
  },
  input: {
    padding: '0.75rem',
    border: '1px solid #ccc',
    borderRadius: '8px',
    fontSize: '1rem',
    transition: 'border-color 0.3s'
  },
  textarea: {
    padding: '0.75rem',
    border: '1px solid #ccc',
    borderRadius: '8px',
    fontSize: '1rem',
    resize: 'vertical',
    minHeight: '120px',
    transition: 'border-color 0.3s'
  },
  select: {
    padding: '0.75rem',
    border: '1px solid #ccc',
    borderRadius: '8px',
    fontSize: '1rem',
    backgroundColor: 'white',
    transition: 'border-color 0.3s'
  },
  submitButton: {
    backgroundColor: '#494eb6',
    color: 'white',
    padding: '1rem 1.5rem',
    fontSize: '1rem',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'opacity 0.3s',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
  },

  // Footer Styles
  footer: {
    backgroundColor: '#494eb6',
    color: 'white',
    padding: '2rem 1rem',
    textAlign: 'center'
  },
  footerContainer: {
    maxWidth: '1200px',
    margin: '0 auto'
  },
  footerLogo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '1rem'
  },
  footerTitle: {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    marginLeft: '0.5rem'
  },
  footerDescription: {
    marginBottom: '1rem',
    opacity: 0.9
  },
  footerLinks: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    alignItems: 'center'
  },
  footerLink: {
    color: 'white',
    textDecoration: 'none',
    transition: 'color 0.3s'
  },
  footerCopyright: {
    marginTop: '1.5rem',
    paddingTop: '1.5rem',
    borderTop: '1px solid rgba(255, 255, 255, 0.2)',
    fontSize: '0.875rem',
    opacity: 0.8
  }
};